<template>
    <div>
        <div class="form-actions flex justify-between">
            <div class="flex vx-col-action">
                <vs-input icon-pack="feather" icon="icon-search" placeholder="Type here..." v-model="globalSearchTerm" class="is-label-placeholder searchBar-input" id="filter-text-box" v-on:input="onFilterTextBoxChanged()" />
                <span class="br-line mr-2 ml-2"></span>
            </div>
            <div class="float-right flex">
                <vx-tooltip text="Add Reseller" position="top" v-if="user_role == 'user' || user_role == 'admin' || user_role == 'superadmin'">
                    <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-plus" @click="addReseller()"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Download list" position="top">
                    <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-download" @click="downloadData()"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Reset Filters" position="top">
                    <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshPageWithFilters()"></vs-button>
                </vx-tooltip>
            </div>
        </div>

        <div id="grid-loader" class="vx-card vs-con-loading__container">
            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 ag-grid-table reseller-list-grid" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :components="components" :rowData="tableData" rowSelection="multiple" :enableRangeSelection="true" :suppressCopyRowsToClipboard="true" :suppressDragLeaveHidesColumns="true" :animateRows="false" :floatingFilter="true" :pagination="true" paginationAutoPageSize=true :suppressPaginationPanel="true" :suppressRowClickSelection="true" :rowClassRules="rowClassRules" :statusBar="statusBar" :sideBar="sideBar" :rowHeight="30" :headerHeight="30" :floatingFiltersHeight="35" :checkboxSelection="true" @filter-changed="onFilterChanged" @row-selected="onRowSelected" @pagination-changed="onPaginationChanged" @column-resized="onColumnResized">
            </ag-grid-vue>
            <div class="vx-row py-5">
                <div class="vx-col w-full">
                    <vs-pagination :total="totalPages" :max="maxPageNumbers" class="custom-pagination" v-model="currentPage" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import CellRendererViewAndEditPartnerActions from "@/components/ag-grid-tables/actions/CellRendererViewAndEditPartnerActions.vue";

export default {
    name: 'ResellerList',
    components: {
        AgGridVue,
        CellRendererViewAndEditPartnerActions
    },
    data() {
        return {
            // NOTE: AG-GRID
            gridOptions: {},
            gridApi: null,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                resizable: true,
                suppressMenu: true,
                suppressMovable: false,
                filterParams: {
                    suppressAndOrCondition: true,
                    newRowsAction: "keep",
                },
            },
            autoGroupColumnDef: null,
            maxPageNumbers: 7,
            rowClassRules: null,
            statusBar: null,
            sideBar: null,
            tableData: null,
            selectedRowCount: "",
            selectedNonEditableRow: false,
            components: {},
            globalSearchTerm: "",
            flags: {
                selectedAll: [],
            },
            formInit: {
                nameServers: [],
                groupEntity: [],
                billingEntity: []
            },
        }
    },
    beforeMount() {
        this.disableQueue();
        // Table Data AXIOS Call
        this.populateTableData();
        // Reset movable columns on mobile
        this.toggleColumnMovable(this.windowWidth);

        (this.columnDefs = [
            {
                headerName: "Reseller Short Name",
                field: "name",
                filter: "agSetColumnFilter",
                // checkboxSelection: true,
                minWidth: 150,
                width: 250,
                pinned: "left",
                cellClass: "cellCustomWrap",
            },
            {
                headerName: "BI Reseller Short Name",
                field: "bi_client_shortname",
                filter: "agSetColumnFilter",
                minWidth: 150,
                width: 250,
                cellClass: "cellCustomWrap",
                hide: true
            },
            {
                headerName: "Account Manager",
                field: "accountManager",
                filter: "agSetColumnFilter",
                minWidth: 200,
                width: 200
            },
            {
                headerName: "Registrar",
                field: "registrar",
                filter: "agSetColumnFilter",
                minWidth: 180,
                width: 180
            },
            {
                headerName: "List Based",
                field: "listBased",
                filter: "agTextColumnFilter",
                minWidth: 120,
                width: 120
            },
            {
                headerName: "List Frequency",
                field: "listFrequency",
                filter: "agTextColumnFilter",
                minWidth: 150,
                width: 150
            },
            {
                headerName: "Payment Mode",
                field: "paymentMode",
                filter: "agSetColumnFilter",
                minWidth: 150,
                width: 150
            },
            {
                headerName: "Country",
                field: "country",
                filter: "agSetColumnFilter",
                minWidth: 130,
                width: 130
            },
            {
                headerName: "Custom List",
                field: "customList",
                filter: "agSetColumnFilter",
                minWidth: 150,
                width: 150
            },
            {
                headerName: "Actions",
                field: "actions",
                cellRendererFramework: "CellRendererViewAndEditPartnerActions",
                cellRendererParams: {
                    source: "reseller",
                },
                // NOTE: Hide view & edit actions if user role is not any of these
                hide: !(this.$acl.check('isSuperAdmin') || this.$acl.check('isChannelAdmin') || this.$acl.check('isChannelUser') || this.$acl.check('isBIAdmin')),
                minWidth: 100,
                width: 100
            },
        ]),
        // Set Grid sidebar
        (this.sideBar = {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressSideButtons: true,
                        suppressColumnSelectAll: true,
                        suppressColumnExpandAll: true,
                    },
                },
            ],
        });
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        //agigrid loader
        this.gridApi.showLoadingOverlay();
        // Resize to fit columns
        this.sizeColumnsToFit();
        // Reset pinned columns on mobile
        this.toggleColumnPinned(this.windowWidth);

        // Page Download Event
        this.$root.$on("downloadResellerList", () => {
            // AgGrid CSV Export
            this.gridApi.exportDataAsCsv();
        });
        
        // Refresh list after edit popup is closed
        this.$root.$on('refreshResellerList', () => {
            this.populateTableData();
        })
    },
    computed: {
        windowWidth: function () {
            return this.$store.state.windowWidth;
        },
        user_role() {
            return JSON.parse(localStorage.getItem("userDetails")).role;
        },
        user_id() {
            return JSON.parse(localStorage.getItem("userDetails")).id;
        },
        status() {
            // console.log(data && data ? data.status:'');
            return event.node;
        },
        paginationPageSize() {
            if (this.gridApi) {
                return this.gridApi.paginationGetPageSize();
            } else {
                return 15;
            }
        },
        totalPages() {
            if (this.gridApi) {
                return this.gridApi.paginationGetTotalPages();
            } else {
                return 0;
            }
        },
        scrollbarTag() {
            return this.$store.getters.scrollbarTag;
        },
        currentPage: {
            get() {
                if (this.gridApi)
                    return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
            },
        },
        formGeo() {
            return this.$store.getters.formGeo;
        },
        formNameservers() {
            if(this.formInit['nameServers'].length) {
                return this.formInit['nameServers'].map(x => {
                return {
                    label: x['name'],
                    value: x['id']
                }
                })
            } else {
                return [{
                label: 'Select',
                value: null
                }];
            }
        },
        formGroupEntity() {
            if(this.formInit['groupEntity'].length) {
                return this.formInit['groupEntity'].map(x => {
                return {
                    label: x['name'],
                    value: x['id']
                }
                })
            } else {
                return [{
                label: 'Select',
                value: null
                }];
            }
        },
        formBooleanValues() {
            return [{
                label: 'Yes',
                value: 'yes'
            },
            {
                label: 'No',
                value: 'no'
            }]
        },
        formListFrequency() {
            return [{
                label: 'Monthly',
                value: 'monthly'
            },
            {
                label: 'Quarterly',
                value: 'quarterly'
            }]
        },
        formPaymentMode() {
            return [{
                label: 'CNIC',
                value: 'cnic'
            },
            {
                label: 'Direct',
                value: 'bank'
            }]
        },
        formBillingEntity() {
            if(this.formInit['billingEntity'].length) {
                return this.formInit['billingEntity'].map(x => {
                return {
                    label: x['name'],
                    value: x['id']
                }
                })
            } else {
                return [{
                label: 'Select',
                value: null
                }];
            }
        },
    },
    methods: {
        initSelectedAllFlag() {
            if (this.tableData.length) {
                for (let i = 0; i < this.gridApi.paginationGetTotalPages(); i++) {
                    this.flags["selectedAll"].push(false);
                }
            }
        },
        onPageSizeChanged(newPageSize) {
            var value = document.getElementById("page-size").value;
            this.gridApi.paginationSetPageSize(Number(value));
        },
        onPaginationChanged() {
            // console.log('pagechanges');
            if (this.gridApi) {
                (this.totalRows = this.gridApi.paginationGetRowCount()),
                    (this.currentPageSize =
                        this.gridApi.paginationGetPageSize());
            }
        },
        onRowSelected(event) {
            var getStatus = this.gridApi
                .getSelectedNodes()
                .map((x) => x.data)
                .map((x) => x.status);
            getStatus.includes("expired")
                ? (this.selectedNonEditableRow = true)
                : (this.selectedNonEditableRow = false);
            if (event.node.selected) {
                // Push to selectedPromos
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
                if (this.selectedRowCount > 30) {
                    event.node.setSelected(false);
                    this.$vs.notify({
                        time: 5000,
                        color: "warning",
                        title: "Warning",
                        text: "You may select only upto 30 rows",
                    });
                }
            } else {
                // Remove from selectedPromos
                // this.removeFromArray(this.selectedPromos, event.node.childrenAfterGroup[0].data, 'id');
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
                // console.log('row-count', this.selectedRowCount);
            }
        },
        onFilterChanged() {
            this.deselectAllSelectedRows();
        },
        onFilterTextBoxChanged() {
            this.gridApi.setQuickFilter(
                document.getElementById("filter-text-box").value
            );
            this.deselectAllSelectedRows();
        },
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.8,
            });
        },
        hideLoadingInDiv() {
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        },
        toggleColumnMovable(val) {
            if (val <= 576) {
                this.defaultColDef["suppressMovable"] = true;
            } else {
                this.defaultColDef["suppressMovable"] = false;
            }
        },
        toggleColumnPinned(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("reseller_name", null);
                // this.gridOptions.columnApi.setColumnPinned("actions", null);
            } else {
                this.gridOptions.columnApi.setColumnPinned("reseller_name", "left");
                // this.gridOptions.columnApi.setColumnPinned("actions", "right");
            }
        },
        onColumnResized() {
            this.gridApi.resetRowHeights();
        },
        sizeColumnsToFit() {
            this.gridApi.sizeColumnsToFit();
        },
        disableQueue() {
            // Old Logic
            this.rowClassRules = {
                "ag-row-disabled": 'data && (data.status == "edit pending")',
                "ag-checkbox-disabled": 'data && (data.status == "edit pending") && (data.status == "approval pending")',
            };
        },
        downloadData() {
            this.$root.$emit("downloadResellerList");
        },
        refreshPageWithFilters() {
            this.initSelectedAllFlag();
            // Reset filters
            this.gridApi.setFilterModel(null);
            // Reset selection
            this.gridApi.deselectAll();
            // Reset sort
            this.gridApi.setSortModel(null);
            // Table Data AXIOS Call
            this.populateTableData();
        },
        populateTableData() {
            this.$axiosSecure
            .get('/v2/resellers')
            .then((response) => {
                this.tableData = response.data;

                if (this.gridApi) {
                    setTimeout(() => {
                        this.initSelectedAllFlag();
                    }, 1000);
                }

                this.tableData.map(x => {
                    x['accountManager'] = x['new_reseller_client_am'] && x['new_reseller_client_am'][0] && x['new_reseller_client_am'][0]['user'] ? x['new_reseller_client_am'][0]['user']['name'] : 'NA'
                    x['registrar'] = x['unique_registrar'] ? x['unique_registrar']['name'] : null;
                    x['listBased'] = x['client_detail'] && x['client_detail']['list_based'] ? this.formBooleanValues.find(y => y.value == (x['client_detail']['list_based'])).label : null;
                    x['listFrequency'] = x['client_detail'] && x['client_detail']['list_frequency'] ? this.formListFrequency.find(y => y.value == (x['client_detail']['list_frequency'])).label : null;
                    x['paymentMode'] = x['client_detail'] && x['client_detail']['payment_mode'] ? this.formPaymentMode.find(y => y.value == (x['client_detail']['payment_mode'])).label : null;
                    x['customList'] = x['client_detail'] && x['client_detail']['custom_list'] ? this.formBooleanValues.find(y => y.value == (x['client_detail']['custom_list'])).label : null;
                    x['country'] = x['country_id'] &&  this.formGeo.find(y => y.value == x['country_id']) ? this.formGeo.find(y => y.value == x['country_id']).label : null;
                })

            })
            .catch((error) => {
                console.log('error :>> ', error);
                // Error notification
                this.$vs.notify({
                    color: "danger",
                    title: "Something went wrong",
                    text: "Please contact the server admin",
                });

                console.log(error);
            });
        },
        addReseller() {
            this.$router.push('/partners/add-reseller');
        },
        deselectAllSelectedRows() {
            this.gridApi.deselectAll();

            this.flags["selectedAll"].fill(false);
        },
        gridSelectAll() {
            this.gridApi.forEachNodeAfterFilter((node) => {
                if (
                    !(
                        node.data.status == "new approved" ||
                        node.data.status == "rejected" ||
                        node.data.status == "error"
                    )
                ) {
                    if (
                        node["rowIndex"] >=
                            (this.currentPage - 1) *
                                this.gridApi.paginationGetPageSize() &&
                        node["rowIndex"] <
                            this.currentPage *
                                this.gridApi.paginationGetPageSize()
                    ) {
                        node.setSelected(true);
                    }
                }
            });
        },
        gridDeselectAll() {
            this.gridApi.forEachNodeAfterFilter((node) => {
                if (
                    node["rowIndex"] >=
                        (this.currentPage - 1) *
                            this.gridApi.paginationGetPageSize() &&
                    node["rowIndex"] <
                        this.currentPage * this.gridApi.paginationGetPageSize()
                ) {
                    node.setSelected(false);
                }
            });
        },
        toggleSelectAll() {
            if (this.flags["selectedAll"][this.currentPage - 1]) {
                this.gridDeselectAll();
                this.flags["selectedAll"][this.currentPage - 1] =
                    !this.flags["selectedAll"][this.currentPage - 1];
            } else {
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
                if (
                    this.selectedRowCount < 30 &&
                    this.selectedRowCount + 15 <= 30
                ) {
                    this.gridSelectAll();
                    this.flags["selectedAll"][this.currentPage - 1] =
                        !this.flags["selectedAll"][this.currentPage - 1];
                } else {
                    this.$vs.notify({
                        time: 5000,
                        color: "warning",
                        title: "Warning",
                        text: "You may select only upto 30 rows",
                    });
                }
            }
        },
    },
    destroyed() {
        this.$root.$off('refreshResellerList');
        this.$root.$off('downloadResellerList');
    }
}
</script>
<style>
</style>